export default {
  install(Vue) {
    Vue.filter("moneyFormat", function (v, prefix, precision = 2) {
      if (dsf.isUnDef(v) || v == "") {
        return "";
      }
      // 转换为字符串并处理
      const numStr = v.toString().trim();
      if (!/^\d+(\.\d+)?$/.test(numStr)) {
        return "";
      }
      // 拆分为整数和小数部分
      let [intPart, decPart] = numStr.split(".");
      decPart = (decPart || "").padEnd(2, "0").substring(0, precision); // 补零并限制最多两位
      // 添加千分位逗号分隔符
      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return `${prefix}${intPart}.${decPart}`;
    });
  }
};
